module.exports = __webpack_public_path__ + "img/1587326252.fda13341.jpg";